import React from 'react';
import {
    Dialog,
    DialogActions,
    Button,
    DialogContent,
    DialogContentText,
    DialogTitle,
    makeStyles
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    title: {
        fontSize: 20,
        fontFamily: 'Roboto',
        lineHeight: '32px',
        textAlign: 'center',
        paddingTop: '24px'
    },
    main: {
        textAlign: 'center',
        paddingTop: '24px'
    },
    content: {
        color: '#000000',
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 'normal',
        fontFamily: 'Roboto'
    }
}))
export default ({
    title="Thất Bại",
    isShowDialog,
    close,
    content="OTP Hết hạn",
}) => {
    const classes = useStyles();

    const handleClose = () => {
        close()
    }
    return (
        <Dialog
            className={classes.main}
            open={isShowDialog}
            onClose={close}
            fullWidth
            maxWidth={"xs"}
            disableBackdropClick={true}
        >
            <DialogTitle className={classes.title}>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText className={classes.content}>
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Đóng
                </Button>
            </DialogActions>
        </Dialog>
    )
}